export const createAccount = (data) => ({
  url: '/user/create',
  method: 'POST',
  data,
});

export const editAccount = (data) => ({
  url: '/user/update',
  method: 'PUT',
  data,
});

export const deleteAccount = (data) => ({
  url: '/user/delete',
  method: 'DELETE',
  data,
});

export const renewPassword = (data) => ({
  url: '/user/renew-password',
  method: 'POST',
  data,
});

export const getUserById = (id) => ({
  url: `/user/getuserbyid?userId=${id}`,
  method: 'GET',
});

export const getInformations = ({ dateBegin = null, dateEnd = null }) => ({
  url: `/dashboard${
    dateBegin === null || dateEnd === null
      ? ''
      : `?dateBegin=${dateBegin}&dateEnd=${dateEnd}`
  }`,
  method: 'GET',
});

export const getHistoryOrders = () => ({
  url: `/deliveryorder/delivered-orders`,
  method: 'GET',
});

export const createWarehouse = (data) => ({
  url: '/warehouse/create-warehouse',
  method: 'POST',
  data,
});

export const editWarehouse = (data) => ({
  url: '/warehouse/update-warehouse',
  method: 'POST',
  data,
});

export const deleteWarehouse = (id) => ({
  url: `/warehouse/delete-warehouse?warehouseId=${id}`,
  method: 'POST',
});

export const getWarehouseById = (id) => ({
  url: `/warehouse/warehousebyid?warehouseId=${id}`,
  method: 'GET',
});
